import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const QrLink = async (data) => {
  let response = null;
  try {
    response = await axios.post(
      webView ? `/link/ajax/new${banner}` : `/link/ajax/new`,
      {
        link: data[0],
        advertisingIabCategories: data[1],
        force_create: data[2],
        qrTitle: data[3],
        type: data[4],
        token: token,
      }
    );
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrLinkEdit = async (data) => {
  let response = null;
  try {
    response = await axios.post(`/link/ajax/edit/${data[0]}`, {
      link: data[1],
      advertisingIabCategories: data[2],
      force_create: data[3],
      qrTitle: data[4],
      type: data[5],
      token: token,
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
